import React, { useState, useEffect, useCallback } from "react";
import { Link, useLocation } from "react-router-dom";
import queryString from "query-string";
import styled from "styled-components";
import axios from "axios";
import ScaleLoader from "react-spinners/ScaleLoader";
import "./TestDetails.css";

const apiUrl = "https://utility.cscoreentities.devtest.gf.aws.scania.com/loadrunner";

const Root = styled.div`
  height: 100%;
  width: 90%;
  margin-left: 5.8rem;
  margin-top: 2.8rem;
  text-align: left;
`;
const TableContainer = styled.div`
  background-color: white;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
`;
const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
`;
const TableHead = styled.thead`
  background-color: #154360;
  color: black;
`;
const TableRow = styled.tr`
  &:nth-of-type(odd) {
    background-color: #f2f2f2;
  }
`;
const TableHeader = styled.th`
  padding: 12px;
  text-align: left;
  color: black;
`;
const TableBody = styled.tbody``;
const TableCell = styled.td`
  padding: 12px;
  text-align: left;
  font-size: 14px;
`;

function TestDetails() {
  const storedJwt = localStorage.getItem("token");
  const [jwt] = useState(storedJwt || null);
  const [isLoading, setIsLoading] = useState(false);
  const [testResult, setTestResult] = useState([]);
  const [testResultFromDb, setTestResultFromDb] = useState([]);
  const location = useLocation();
  const testUUId = queryString.parse(location.search).testUUId;

  const getResultsfromS3 = useCallback(async () => {
    try {
      setIsLoading(true);
      const options = {
        headers: {
          "Content-Type": "application/json",
          "X-Client": "ce/pulse-web-console",
          "Access-Control-Allow-Origin": "*",
          Authorization: jwt,
        },
      };

      const { data } = await axios.post(
        `${apiUrl}/jwt/api/v1/GetAllTestResultsFromDb`,
        {
          UUID: testUUId,
        },
        options
      );
      setTestResultFromDb(data);

      let s3Response = await axios.post(
        `${apiUrl}/jwt/api/v1/GetTestResultsFromS3`,
        {
          TEST_ID: "taurus_execution",
          S3_BUCKET: "ankur-test-taurus-docker",
          PREFIX: "ce",
          TEST_VAR: "testing from web-console",
          UUID: testUUId,
        },
        options
      );
      setTestResult(s3Response.data);
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      console.error(err);
    }
  }, [jwt, testUUId]); // Include jwt and testUUId as dependencies

  useEffect(() => {
    getResultsfromS3();
  }, [getResultsfromS3]); // Include getResultsfromS3 as a dependency

  return (
    <>
      {isLoading ? (
        <div className="loading">
          <ScaleLoader height="30px" width="10px" color="#4287f5" />
        </div>
      ) : (
        <div style={{ height: "38px", width: "100%", clear: "both" }}></div>
      )}
      <Root>
        <TableContainer>
          <StyledTable>
            <TableHead>
              <TableRow>
                <TableHeader width="50px">Report Parameter</TableHeader>
                <TableHeader width="250px" align="left">
                  Value
                </TableHeader>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell align="left">Test UUId</TableCell>
                <TableCell align="left">{testResultFromDb.uuid}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell align="left">Test Status</TableCell>
                <TableCell align="left">{testResultFromDb.status}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell align="left">Test Duration</TableCell>
                <TableCell align="left">{testResultFromDb.holdFor}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell align="left">Concurrency</TableCell>
                <TableCell align="left">
                  {testResultFromDb.concurrency}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell align="left">Uri</TableCell>
                <TableCell align="left">{testResultFromDb.uri}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell align="left">HttpMethod</TableCell>
                <TableCell align="left">
                  {testResultFromDb.httpMethod}
                </TableCell>
              </TableRow>
              {testResultFromDb.methodBody && (
                <TableRow>
                  <TableCell align="left">MethodBody</TableCell>
                  <TableCell align="left">
                    {testResultFromDb.methodBody}
                  </TableCell>
                </TableRow>
              )}
              <TableRow>
                <TableCell align="left">RampUp</TableCell>
                <TableCell align="left">{testResultFromDb.rampUp}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell align="left">Date Initiated</TableCell>
                <TableCell align="left">
                  {testResultFromDb.dateInitiated}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell align="left">Report URL</TableCell>
                <TableCell align="left">
                  <a
                    href={testResult.reportURL}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Report Link
                  </a>
                </TableCell>
              </TableRow>
            </TableBody>
          </StyledTable>
        </TableContainer>
      </Root>
      <div className="testdetails-page-form">
        <Link to="/Dashboard">
          <button type="button">Dashboard</button>
        </Link>
      </div>
    </>
  );
}

export default TestDetails;
